import React from 'react';
import { FadeIn } from '../components/FadeIn';
import { Divider } from '../components/Divider';
import { Button } from '../components/Button';
import { CheckList, StarList } from '../components/Lists';
export function Landing() {
  return <main className="w-full min-h-screen bg-brand-charcoal text-brand-cream overflow-x-hidden" data-id="element-19">
      {/* SECCIÓN 1 — HERO */}
      <section className="w-full relative" data-id="element-20">
        <a href="https://pay.hotmart.com/N106344754R?off=9fw6qwmk" target="_blank" rel="noopener noreferrer" className="block focus:outline-none focus:ring-2 focus:ring-brand-gold" aria-label="Quiero reservar mi lugar" data-id="element-21">
          <img src="https://cdn.magicpatterns.com/uploads/c6JK4Hz5KMCvk8g5emYCCc/hero_kamasutra_para_enamorar.jpg" alt="Kamasutra para Enamorar - Clase especial en vivo con la DOC Beatriz Espina" className="w-full h-auto object-cover" data-id="element-22" />
        </a>
      </section>

      {/* SECCIÓN 2 — Apertura honesta */}
      <section className="max-w-3xl mx-auto px-6 py-16 md:py-24 text-center" data-id="element-23">
        <FadeIn data-id="element-24">
          <div className="space-y-6 font-serif text-2xl md:text-3xl leading-relaxed text-brand-cream/90" data-id="element-25">
            <p data-id="element-26">Seamos honestos...</p>
            <p data-id="element-27">Nos enseñaron muchas cosas.</p>
            <p data-id="element-28">A estudiar.</p>
            <p data-id="element-29">A trabajar.</p>
            <p data-id="element-30">A construir una carrera.</p>
            <p data-id="element-31">A formar una familia.</p>
            <p data-id="element-32">A resolver problemas.</p>
            <p data-id="element-33">A cumplir responsabilidades.</p>
            <p className="pt-8 text-brand-gold" data-id="element-34">
              Pero casi nadie nos enseñó cómo mantener viva la conexión dentro
              de una relación.
            </p>
            <p data-id="element-35">Cómo seguir eligiéndonos cuando pasan los años.</p>
            <p data-id="element-36">
              Cómo evitar que la rutina ocupe el espacio donde antes vivían la
              emoción, la curiosidad y la complicidad.
            </p>
            <p data-id="element-37">Cómo hablar de deseo con naturalidad.</p>
            <p data-id="element-38">
              Cómo construir cercanía cuando la vida se vuelve cada vez más
              exigente.
            </p>
          </div>
        </FadeIn>
      </section>

      <Divider data-id="element-39" />

      {/* SECCIÓN 3 — Preguntas retóricas */}
      <section className="max-w-6xl mx-auto px-6 py-12 md:py-20" data-id="element-40">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-41">
          <FadeIn className="order-2 md:order-1" data-id="element-42">
            <div className="space-y-8 font-serif text-xl md:text-2xl leading-relaxed" data-id="element-43">
              <p className="text-brand-gold italic" data-id="element-44">
                Y por eso tantas personas terminan preguntándose…
              </p>

              <div className="space-y-6 pl-4 border-l-2 border-brand-wine/50" data-id="element-45">
                <p data-id="element-46">¿Qué pasó con nosotros?</p>
                <p data-id="element-47">¿En qué momento dejamos de sorprendernos?</p>
                <p data-id="element-48">¿Por qué ya no nos buscamos igual?</p>
                <p data-id="element-49">
                  ¿Por qué las conversaciones importantes dejaron de ocurrir?
                </p>
                <p data-id="element-50">¿Por qué seguimos juntos... pero nos sentimos más lejos?</p>
              </div>

              <p className="pt-8 font-sans font-light text-lg text-brand-cream/80" data-id="element-51">
                La mayoría piensa que el problema es la falta de tiempo. O el
                estrés. O la edad. Pero muchas veces el verdadero problema es
                otro. Nadie nos enseñó cómo cuidar una relación después del
                enamoramiento.
              </p>
            </div>
          </FadeIn>
          <FadeIn className="order-1 md:order-2" data-id="element-52">
            <img src="https://cdn.magicpatterns.com/uploads/dSv7XRVZJ5tR1eotG8ByFv/Imagen_2_kamasutra_para_enamorar.jpg" alt="Beatriz Espina" className="w-full rounded-lg shadow-2xl shadow-brand-black/50" data-id="element-53" />
          </FadeIn>
        </div>
      </section>

      {/* SECCIÓN 4 — Profundización emocional */}
      <section className="max-w-6xl mx-auto px-6 py-12 md:py-20" data-id="element-54">
        <div className="grid md:grid-cols-12 gap-12 items-center" data-id="element-55">
          <FadeIn className="md:col-span-5" data-id="element-56">
            <img src="https://cdn.magicpatterns.com/uploads/prQY4FyxunSbefp8vv6K2V/Imagen_3_kamasutra_para_enamorar.jpg" alt="Beatriz Espina retrato" className="w-full max-w-md mx-auto rounded-lg shadow-2xl shadow-brand-black/50" data-id="element-57" />
          </FadeIn>
          <FadeIn className="md:col-span-7" data-id="element-58">
            <div className="space-y-6 font-serif text-2xl md:text-3xl leading-relaxed text-brand-cream/90" data-id="element-59">
              <p data-id="element-60">Porque el amor no suele desaparecer de golpe.</p>
              <p className="text-brand-gold" data-id="element-61">La conexión sí.</p>
              <p data-id="element-62">Se va apagando lentamente.</p>
              <p data-id="element-63">Entre responsabilidades.</p>
              <p data-id="element-64">Pendientes.</p>
              <p data-id="element-65">Rutinas.</p>
              <p data-id="element-66">Preocupaciones.</p>
              <p data-id="element-67">Y días que se parecen demasiado entre sí.</p>
              <p className="pt-6" data-id="element-68">
                Hasta que un día descubres que todavía hay cariño...
              </p>
              <p className="text-brand-gold italic" data-id="element-69">
                Pero extrañas la chispa. La cercanía. La emoción. La
                complicidad.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <Divider data-id="element-70" />

      {/* SECCIÓN 5 — Presentación del programa */}
      <section className="max-w-4xl mx-auto px-6 py-16 md:py-24 text-center" data-id="element-71">
        <FadeIn data-id="element-72">
          <h2 className="font-serif text-4xl md:text-6xl text-brand-gold mb-4" data-id="element-73">
            Por eso nace
          </h2>
          <div className="mb-12" data-id="element-74">
            <span className="block font-serif text-5xl md:text-7xl tracking-widest text-brand-gold" data-id="element-75">
              KAMASUTRA
            </span>
            <span className="block font-script text-5xl md:text-7xl text-brand-wine -mt-4 md:-mt-8 mb-4" data-id="element-76">
              para
            </span>
            <span className="block font-serif text-4xl md:text-6xl tracking-[0.2em] text-brand-wine" data-id="element-77">
              ENAMORAR
            </span>
          </div>
          <p className="font-sans font-light text-lg md:text-xl leading-relaxed text-brand-cream/90 max-w-3xl mx-auto" data-id="element-78">
            Y no. No es una clase más sobre posiciones. Es una experiencia
            diseñada para ayudarte a comprender algo mucho más importante: Cómo
            utilizar el Kamasutra como una herramienta para fortalecer la
            conexión, la confianza, la comunicación y el deseo dentro de una
            relación real. Porque el verdadero valor del Kamasutra nunca estuvo
            en las posiciones. Estuvo en la capacidad de ayudar a dos personas a
            encontrarse nuevamente.
          </p>
        </FadeIn>
      </section>

      {/* SECCIÓN 6 — Lo que aprenderán */}
      <section className="bg-brand-black/40 py-16 md:py-24" data-id="element-79">
        <div className="max-w-4xl mx-auto px-6" data-id="element-80">
          <FadeIn data-id="element-81">
            <p className="font-serif text-2xl md:text-3xl text-center mb-12 text-brand-cream/90" data-id="element-82">
              Y sí... También hablaremos de posiciones. La DOC compartirá una
              selección especial de posiciones explicadas desde una mirada
              profesional, práctica y segura. Aprenderás:
            </p>

            <div className="bg-brand-charcoal/80 p-8 md:p-12 rounded-2xl border border-brand-wine/20 shadow-xl mb-12" data-id="element-83">
              <CheckList items={['Cómo realizarlas correctamente.', 'Qué beneficios aporta cada una.', 'Cómo adaptarlas a diferentes etapas de vida.', 'Qué errores evitar.', 'Cómo utilizarlas para generar mayor cercanía, comodidad y conexión.', 'Cómo incorporar novedad sin presión ni incomodidad.']} data-id="element-84" />
            </div>

            <p className="font-serif text-2xl md:text-3xl text-center text-brand-gold italic" data-id="element-85">
              Porque aprender algo nuevo juntos puede convertirse en una de las
              formas más poderosas de volver a conectar.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* SECCIÓN 7 — Esta experiencia es para ti si... */}
      <section className="max-w-5xl mx-auto px-6 py-16 md:py-24" data-id="element-86">
        <FadeIn data-id="element-87">
          <h2 className="font-serif text-4xl md:text-5xl text-center text-brand-gold mb-12" data-id="element-88">
            Esta experiencia es para ti si...
          </h2>
          <CheckList columns={2} items={['Sientes que la rutina ganó demasiado espacio.', 'Quieres recuperar conexión en tu relación.', 'Deseas comprender mejor el deseo y la intimidad.', 'Te interesa aprender desde una mirada profesional y respetuosa.', 'Quieres herramientas prácticas que puedas aplicar.', 'Buscas fortalecer la complicidad y la confianza.', 'Crees que una buena relación también se construye aprendiendo.']} data-id="element-89" />
        </FadeIn>
      </section>

      {/* SECCIÓN 8 — Lo que descubrirás */}
      <section className="bg-brand-wineDark/20 py-16 md:py-24" data-id="element-90">
        <div className="max-w-5xl mx-auto px-6" data-id="element-91">
          <FadeIn className="mb-12" data-id="element-92">
            <img src="https://cdn.magicpatterns.com/uploads/kkfQEbWruaCJz75dhyyNkv/imagen_4_kamasutra_para_enamorar.jpg" alt="Pareja sonriendo" className="w-full h-[300px] md:h-[400px] object-cover rounded-2xl shadow-2xl" data-id="element-93" />
          </FadeIn>

          <FadeIn data-id="element-94">
            <h2 className="font-serif text-4xl md:text-5xl text-center text-brand-gold mb-12" data-id="element-95">
              Lo que descubrirás durante esta clase
            </h2>
            <div className="max-w-3xl mx-auto" data-id="element-96">
              <StarList items={['El verdadero significado del Kamasutra más allá de los mitos.', 'Lo que nadie nos enseñó sobre deseo, rutina y conexión.', 'Posiciones seleccionadas para favorecer cercanía y complicidad.', 'Herramientas para fortalecer la comunicación íntima.', 'Factores que influyen en la conexión emocional.', 'Cómo recuperar juego, curiosidad y novedad dentro de una relación.', 'Estrategias para construir relaciones más conscientes y satisfactorias.']} data-id="element-97" />
            </div>
          </FadeIn>
        </div>
      </section>

      <Divider data-id="element-98" />

      {/* SECCIÓN 9 — Diferenciador */}
      <section className="max-w-4xl mx-auto px-6 py-12 md:py-20 text-center" data-id="element-99">
        <FadeIn data-id="element-100">
          <h2 className="font-serif text-3xl md:text-4xl text-brand-gold mb-12" data-id="element-101">
            Lo que hace diferente esta experiencia
          </h2>
          <div className="space-y-6 font-serif text-2xl md:text-3xl leading-relaxed text-brand-cream/90" data-id="element-102">
            <p data-id="element-103">La DOC no enseña desde el juicio.</p>
            <p data-id="element-104">No enseña desde el morbo.</p>
            <p data-id="element-105">No enseña desde la teoría vacía.</p>
            <p className="text-brand-gold" data-id="element-106">Enseña desde la experiencia.</p>
            <p className="text-brand-gold" data-id="element-107">Desde la educación.</p>
            <p className="text-brand-gold" data-id="element-108">Desde la ciencia.</p>
            <p data-id="element-109">
              Y desde años acompañando a miles de personas a construir
              relaciones más sanas, más conscientes y más felices.
            </p>
            <p className="pt-8 italic text-brand-cream/70 text-xl md:text-2xl" data-id="element-110">
              Todo explicado con la profundidad, cercanía y naturalidad que la
              caracteriza.
            </p>
          </div>
        </FadeIn>
      </section>

      {/* SECCIÓN 10 — Qué recibirás */}
      <section className="max-w-4xl mx-auto px-6 py-12 md:py-20" data-id="element-111">
        <FadeIn data-id="element-112">
          <h2 className="font-serif text-4xl md:text-5xl text-center text-brand-gold mb-12" data-id="element-113">
            Lo que recibirás
          </h2>
          <StarList items={['Experiencia online para que la veas cuantas veces desees', 'Enseñanza guiada por Beatriz Espina', 'Explicación profesional de posiciones seleccionadas', 'Herramientas prácticas de aplicación inmediata']} data-id="element-114" />
        </FadeIn>
      </section>

      {/* Retrato Beatriz Espina */}
      <section className="max-w-3xl mx-auto px-6 pb-12 md:pb-20" data-id="element-115">
        <FadeIn data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/dmJe8jHUuQpNP5GSYJE8pC/Imagen_6_kamasutra_para_enamorar.jpg" alt="Beatriz Espina, la DOC" className="w-full max-w-md mx-auto rounded-lg shadow-2xl shadow-brand-black/50" data-id="element-117" />
        </FadeIn>
      </section>

      {/* SECCIÓN 11 — Reflexión final */}
      <section className="relative py-20 md:py-32" data-id="element-118">
        <div className="absolute inset-0 z-0" data-id="element-119">
          <img src="https://cdn.magicpatterns.com/uploads/u5YboHDh9pB3AeEdYzHvpk/Imagen_5_la_DOC_kamasura_para_enamorar.jpg" alt="Pareja con café" className="w-full h-full object-cover" data-id="element-120" />
          <div className="absolute inset-0 bg-brand-charcoal/80 mix-blend-multiply" data-id="element-121"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-brand-charcoal via-brand-charcoal/60 to-transparent" data-id="element-122"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-123">
          <FadeIn data-id="element-124">
            <div className="space-y-8 font-serif text-2xl md:text-4xl leading-relaxed text-brand-cream shadow-sm" data-id="element-125">
              <p data-id="element-126">Antes de cerrar esta página...</p>
              <p data-id="element-127">Déjame hacerte una pregunta.</p>
              <p className="text-brand-gold pt-8" data-id="element-128">
                Si dentro de un año sigues exactamente igual en esta área de tu
                vida...
              </p>
              <p data-id="element-129">¿Estarías satisfecho?</p>
              <p data-id="element-130">¿Estarías satisfecha?</p>
              <p className="pt-8" data-id="element-131">
                ¿O hay una parte de ti que sabe que todavía existe una mejor
                versión de tu relación?
              </p>
              <p className="text-brand-gold italic" data-id="element-132">
                Una versión con más conexión. Más confianza. Más cercanía. Más
                complicidad. Más vida.
              </p>
              <p className="pt-8 font-sans font-light text-lg md:text-xl text-brand-cream/90" data-id="element-133">
                Porque las grandes relaciones no aparecen por accidente. Se
                construyen. Y todo gran cambio comienza aprendiendo algo que
                antes nadie te enseñó.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* SECCIÓN 12 — Cierre / Ficha del evento */}
      <section className="bg-brand-black py-16 md:py-24 px-6" data-id="element-134">
        <div className="max-w-4xl mx-auto" data-id="element-135">
          <FadeIn data-id="element-136">
            <div className="bg-gradient-to-b from-brand-wineDark/40 to-brand-charcoal border border-brand-gold/20 rounded-3xl p-8 md:p-16 text-center shadow-2xl" data-id="element-137">
              <div className="mb-8" data-id="element-138">
                <span className="block font-serif text-4xl md:text-6xl tracking-widest text-brand-gold" data-id="element-139">
                  KAMASUTRA
                </span>
                <span className="block font-script text-4xl md:text-6xl text-brand-wine -mt-4 md:-mt-6 mb-2" data-id="element-140">
                  para
                </span>
                <span className="block font-serif text-3xl md:text-5xl tracking-[0.2em] text-brand-wine" data-id="element-141">
                  ENAMORAR
                </span>
              </div>

              <p className="font-sans text-lg md:text-xl text-brand-cream/90 max-w-2xl mx-auto mb-12" data-id="element-142">
                Lo que nadie nos enseñó sobre cómo mantener vivo el deseo, la
                conexión y la complicidad en una relación real.
              </p>

              <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 mb-12 font-sans text-brand-cream/80" data-id="element-143">
                <div className="flex items-center gap-2" data-id="element-144">
                  <span className="text-2xl" data-id="element-145">📅</span>
                  <span data-id="element-146">Jueves 25 de Junio</span>
                </div>
                <div className="hidden md:block w-px h-8 bg-brand-gold/30" data-id="element-147"></div>
                <div className="flex items-center gap-2" data-id="element-148">
                  <span className="text-2xl" data-id="element-149">🕘</span>
                  <span data-id="element-150">9:00 PM Argentina</span>
                </div>
                <div className="hidden md:block w-px h-8 bg-brand-gold/30" data-id="element-151"></div>
                <div className="flex items-center gap-2" data-id="element-152">
                  <span className="text-2xl" data-id="element-153">🔒</span>
                  <span data-id="element-154">
                    Acceso exclusivo para alumnas de la DOC e invitados
                    especiales
                  </span>
                </div>
              </div>

              <Button href="https://pay.hotmart.com/N106344754R?off=9fw6qwmk" className="w-full md:w-auto text-sm md:text-base" data-id="element-155">
                RESERVAR MI LUGAR AHORA
              </Button>
            </div>
          </FadeIn>
        </div>
      </section>
    </main>;
}